import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import ClinicalServices from "../ones/ClinicalServices";
import Clinical from "../ones/Clinical";
import Maternal from "../ones/Maternal";
import Diagnosis from "../ones/Diagnosis";
import Pharmacy from "../ones/Pharmacy";
import Specialized from "../ones/Specialized";
import Wellness from "../ones/Wellness";
import Telehealth from "../ones/Telehealth";
import Footer from "../ones/Footer";

export default function Services() {
  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  async function init() {
    // run initializations here
  }

  function getView() {
    if (
      !appContext.navSubItem && 
      !appContext.navExtraItem && 
      !appContext.navMoreItem
    ) {
      return <ClinicalServices />;
    } else if (
      appContext.navSubItem === 'clinical' && 
      !appContext.navExtraItem && 
      !appContext.navMoreItem
    ) {
      return <><Clinical /><Footer/></>;
    } else if (
      appContext.navSubItem === 'maternal' && 
      !appContext.navExtraItem && 
      !appContext.navMoreItem
    ) {
      return <><Maternal /><Footer/></>;
    } else if (
      appContext.navSubItem === 'pharmacy' && 
      !appContext.navExtraItem && 
      !appContext.navMoreItem
    ) {
      return <><Pharmacy /><Footer/></>;
    } else if (
      appContext.navSubItem === 'diagnosis' && 
      !appContext.navExtraItem && 
      !appContext.navMoreItem
    ) {
      return <><Diagnosis /><Footer/></>;
    } else if (
      appContext.navSubItem === 'specialized' && 
      !appContext.navExtraItem && 
      !appContext.navMoreItem
    ) {
      return <><Specialized /><Footer/></>;
    } else if (
      appContext.navSubItem === 'wellness' && 
      !appContext.navExtraItem && 
      !appContext.navMoreItem
    ) {
      return <><Wellness /><Footer/></>;
    } else if (
      appContext.navSubItem === 'telehealth' && 
      !appContext.navExtraItem && 
      !appContext.navMoreItem
    ) {
      return <><Telehealth /><Footer/></>;
    }

      return <ClinicalServices />;
    }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const nextView = getView();
    if (nextView) {
      setView(nextView);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  return view;
}
